module.exports = __webpack_public_path__ + "static/img/banner-home.f579a9c1.jpg";